/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventId,
  getEventName,
  getEventUsernameFieldType,
  getEventLoginUsernameLabel,
  getEventLoginUsernameLegend,
  getEventLoginUsernamePlaceholder,
  getEventLoginUsernameText,
} from '@e180/domain/lib/event/util';

import LoginUsernameFormDumb from './LoginUsernameFormDumb';
// import LazyLoginSupportMain from "../support/login/LazyLoginSupportMain";
import { validateEmail } from 'src/shared/app/authentication/action/base/authenticationActions';
import { showAuthenticationLoginPasswordSection } from 'src/shared/app/authentication/action/base/uiAuthenticationActions';
import {
  getAuthenticationUsername,
  isPasswordReset,
} from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
// import withMount from "../../../base/component/hoc/withMount";
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (state: State, { intl }: Props): Object => {
  const event = getEventSafely(state);
  const { locale } = intl;

  return {
    eventName: getEventName(event, locale),
    username: getAuthenticationUsername(state),
    // $FlowIssue: type only defined for public events
    type: getEventUsernameFieldType(event),
    legend: getEventLoginUsernameLegend(event, locale),
    label: getEventLoginUsernameLabel(event, locale),
    placeholder: getEventLoginUsernamePlaceholder(event, locale),
    note: getEventLoginUsernameText(event, locale),
    isLegendHidden: isPasswordReset(state),
    // Used in `mergeProps` only
    event,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { event } = stateProps;

  return {
    ...stateProps,
    // handleMount() {
    //   LazyLoginSupportMain.preload();
    // },
    handleSubmit({ username }: Object) {
      return dispatch(validateEmail(username, getEventId(event)))
        .then(() => dispatch(showAuthenticationLoginPasswordSection()))
        .catch((e) => throwFormikSubmissionError(e));
    },
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  // withMount
)(LoginUsernameFormDumb);
